import missionHeader from './mission-header.svg';
import charaNormal from './chara-normal.webp';
import missionBadgeComplete from './mission-badge-complete.svg';

export const areaDetailImages = {
  missionHeader,
  charaNormal,
  missionBadgeComplete,
};
